// extracted by mini-css-extract-plugin
export default {"container":"Part2_container__TckjC","leftSide":"Part2_leftSide__Xoup+","rightSide":"Part2_rightSide__3ulru"};